export default "__VITE_ASSET__gt5RfhIhL3AvztJj7_xaRA__"